export var miscErrors = {
    makeMortgageCaseMetaUnassignedFieldError: function (fieldName) {
        return new Error("mortgageCaseMeta.".concat(fieldName, " should be assigned to perform that operation"));
    },
};
